import React from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import { Routes, Route } from "react-router-dom";
import DashboardHome from "../pages/DashboardHome/DashboardHome";
import Customers from "../pages/Customers/Customers";
import Vendors from "../pages/Vendors/Vendors";
import Users from "../pages/Users/Users";
import UserDetails from "../pages/Users/UserDetails";
import Header from "../components/Header/Header";
import Orders from "../pages/Orders/Orders";
import OrderDetails from "../pages/Orders/OrderDetails";
import Regions from "../pages/Regions/Regions";
import Brands from "../pages/Brands/Brands";
import Devices from "../pages/Devices/Devices";
import Models from "../pages/Models/Models";
import Series from "../pages/Series/Series";
import ModelDefectOverrides from "../pages/Models/ModelDefectOverrides";
import ModelQuestionOverrides from "../pages/Models/ModelQuestionOverrides";
import Defects from "../pages/Defects/Defects";
import DefectGroups from "../pages/Defects/DefectGroups";
import DefectGallery from "../pages/DefectGallery/DefectGallery";
import Questions from "../pages/Questions/Questions";
import Analytics from "../pages/Analytics/Analytics";
import Policies from "../pages/Policies/Policies";
import VendorAgreement from "../pages/Policies/VendorAgreement";
import PlatformSettings from "../pages/Settings/PlatformSettings";
import Catalog from "../pages/Catalog/Catalog";
import Advertisements from "../pages/Promotions/Advertisements";
import LuckyDraws from "../pages/Promotions/LuckyDraws";
import PromoCoupons from "../pages/Promotions/PromoCoupons";
import "../styles/admin-common.css";

const AdminLayout = () => (
  <div className="admin-layout">
    <Sidebar />
    <div className="admin-shell">
      <Header />
      <main className="admin-main">
        <Routes>
          <Route path="/" element={<DashboardHome />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/vendors" element={<Vendors />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/:userId" element={<UserDetails />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/order/:orderId" element={<OrderDetails />} />
          <Route path="/regions" element={<Regions />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/models" element={<Models />} />
          <Route path="/series" element={<Series />} />
          <Route path="/models/:deviceId/defects" element={<ModelDefectOverrides />} />
          <Route path="/models/:deviceId/questions" element={<ModelQuestionOverrides />} />
          <Route path="/defects" element={<Defects />} />
          <Route path="/defect-groups" element={<DefectGroups />} />
          <Route path="/defect-gallery" element={<DefectGallery />} />
          <Route path="/questions" element={<Questions />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/policies/vendor-agreement" element={<VendorAgreement />} />
          <Route path="/settings/spotdeal" element={<PlatformSettings />} />
          <Route path="/promotions/ads" element={<Advertisements />} />
          <Route path="/promotions/lucky-draws" element={<LuckyDraws />} />
          <Route path="/promotions/coupons" element={<PromoCoupons />} />
        </Routes>
      </main>
    </div>
  </div>
);

export default AdminLayout;
